import React, { Component } from "react"
import { Link } from "react-router-dom"
import { graphql, compose, withApollo } from "react-apollo"
import { Button} from "@blueprintjs/core"
import {Icon, Tooltip, Position} from "@blueprintjs/core"
import { Row, Col } from 'react-flexbox-grid'
import matchSorter from 'match-sorter'
import ReactTable from "react-table"
import gql from "graphql-tag"
import LinkIcon from "../../_utils/LinkIcon"
import ResultHeader from "../_layout/ResultHeader"
import ShowStatus from "../../_utils/ShowStatus"
import { deleteTask } from '../../../graphql/mutations'
import moment from "moment";

const userTasks = `
query listTasks($id:String!, $limit:Int){
  listTasks(filter: { assignedTo: {eq: $id}}, limit:$limit ){
    items{
      id
      name
      where
      when
      description
      entity
      bounty
      createdAt
      modifiedAt
      status
      count
      createdBy
      assignedTo
      transaction
    }
  }
}`;

class ListTasks extends Component {
  
  state = {
    header:{
      title:'User Tasks',
      counter:'0',
      action:'link',
      action_text:'See all tasks',
      action_icon:'arrow-left',
      action_route:'/q/tasks',
      entityLogo:'',
      entityId:'',
      filter:''
    },
    busy: false,
    
  }
  
  static defaultProps = {
    events: [],
    deleteEvent: () => null,
  }
  
  componentWillReceiveProps(newProps) {
    if (newProps && newProps.tasks) {
      this.updateState(newProps);
    }
  }
  
  
  updateState(props){
    const { header } =  this.state
    
    header.counter =  (props.tasks ? props.tasks.length: '');
    header.title = (props.db_user ? props.db_user.username :'user');
    header.filter = (props.match ? props.match.params.filter :'');
    
    this.setState({ header });
  }
  
  async handleDeleteClick(task, e) {
    e.preventDefault();
    
    if (window.confirm(`Are you sure you want to delete event ${task.id}`)) {
      const { deleteTask } = this.props;
      
      await deleteTask(task);
    }
  }
  
  
  handleSync = async () => {
    const { client } = this.props;
    const query = gql(userTasks);
    
    this.setState({ busy: true });
    
    await client.query({
      query,
      fetchPolicy: 'network-only',
    });
    
    this.setState({ busy: false });
  }
  
  renderEvent = (event) => (
    
    <Link to={`/q/task/${event.id}`} key={event.id}>
      <Row>
        <Col xs={12} md={6} >
          <h3>{event.name}</h3>
          <div>{event.description}</div>
        </Col>
        
        <Col xs={12} md={6} >
          
          <span>{moment(event.when).format('LL')}</span> |
          <span>{moment(event.when).format('LT')}</span> |
          <span>{event.where}</span>
          
          {event.comments.items.length} comments
          <Button className="button" onClick={this.handleDeleteClick.bind(this, event)}>
            Delete
          </Button>
        </Col>
      </Row>
    </Link>
  
  );
  
  renderTable(){
    
    const { tasks } = this.props;
    const { busy } = this.state;
    
    return(
      <ReactTable
        data={tasks}
        noDataText="No Tasks here!"
        filterable
        defaultFilterMethod={(filter, row) =>
        String(row[filter.id]) === filter.value}
        columns={[{
          columns: [
            {
              Header: 'editor_tasks',
              id: "name",
              accessor: d => d.name,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, {keys: ["name"]}),
              filterAll: true,
              Cell: row =>(
                <div>
                  <LinkIcon type={'link'}
                            text={row.value}
                            route={"/q/task/"+row.original.id}
                  />
                  {row.original.createdBy === this.props.db_user.id ? <span className="bp3-tag bp3-round bp3-intent-danger">Created by you</span> :null }
                </div>
              )
            },{
              Header:'Assigned',
              accessor:'createdBy',
              Filter: '-',
              maxWidth: 140,
              Cell: row => {
                if(row.original.assignedTo === this.props.db_user.id){
                  return(
                    <span className="bp3-tag bp3-round bp3-intent-success"> Assigned to you </span>
                  )
                }else if(row.original.assignedTo){
                  return(
                    <span className="bp3-tag bp3-round bp3-intent-warning"> Assigned </span>
                  )
                }else{
                  return(<div>NA</div>)
                }
              }
            },{
              Header:'Entity',
              accessor:'entity',
              Filter: '-',
              maxWidth: 75
            },
            {
              Header:'Bounty',
              accessor:'bounty',
              maxWidth: 50,
              Filter: '-',
              Cell: row =>(
                <div>
                  {row.value}
                </div>
              )
            },
            {
              Header:'Due',
              accessor:'when',
              Filter: '-',
              maxWidth: 50,
              Cell: row =>(
                <div>
                  {moment(row.value).format('MM-DD')}
                </div>
              )
            },
            {
              Header:'Status',
              accessor:'status',
              maxWidth:70,
              Filter: '-',
              Cell: row =>(
                <div>
                  {
                    ShowStatus(row.value, true)
                  }
                
                </div>
              )
            },
            {
              Header:'Actions',
              accessor:'id',
              maxWidth: 60,
              Cell: row => (
                <div className="actions_column">
                  {/*<Tooltip content="Add to my Queue" position={Position.LEFT}>*/}
                  {/*<a onClick={this.handleAddToMyTasks.bind(this, row.original)} className="action_text">*/}
                  {/*<Icon icon="plus" iconSize={11}/>&nbsp; Queue*/}
                  {/*</a>*/}
                  {/*</Tooltip>*/}
                  <Tooltip content="Edit Task" position={Position.LEFT}>
                    <Link to={"/q/task/"+row.original.id+"/edit"}>
                      <Icon icon="edit" iconSize={11}/>
                    </Link>
                  </Tooltip>
                  <Tooltip content="Delete Task" position={Position.LEFT}>
                    <button onClick={this.handleDeleteClick.bind(this, row.original)}>
                      <Icon icon="cross" iconSize={11} />
                    </button>
                  </Tooltip>
                </div>
              ),
              Filter: row =>(
                <Button className="bp3-button bp3-minimal" onClick={this.handleSync} disabled={busy}>
                  <Icon icon={busy ? 'time' : 'refresh' } iconSize={11} />
                </Button>
              )
            }
          ]
        }]}
        defaultPageSize={20}
        className=" -highlight"
      />
    )
    
  }
  
  
  render() {
    return (
      <div>
        <div>
          {this.state.header && <ResultHeader category="Tasks" header={this.state.header} />}
          <div style={{backgroundColor:'yellow'}}>{this.state.header.filter}</div>
        </div>
        <div>
          
          {this.renderTable()}
          
          {/*{[].concat(events).sort((a, b) => a.when.localeCompare(b.when)).map(this.renderEvent)}*/}
        </div>
      </div>
    );
  }
  
}

export default withApollo(compose(
  graphql(
    gql(userTasks),
    {
      options: (props) => ({
        fetchPolicy: 'network-only',
        variables: {id: props.match.params.userId, limit:1000}
      }),
      props: ({ data: { listTasks = { items: [] } } }) => ({
        tasks: listTasks.items
      })
    }
  ),
  graphql(
    gql(deleteTask),
    {
      options: {
        update: (proxy, { data: { deleteTask } }) => {
          const query = gql(userTasks);
          const data = proxy.readQuery({ query });
          
          data.listTasks.items = data.listTasks.items.filter(task => task.id !== deleteTask.id);
          
          proxy.writeQuery({ query, data });
        }
      },
      props: (props) => ({
        deleteTask: (task) => {
          return props.mutate({
            variables: { input:{id: task.id} },
            optimisticResponse: () => ({
              deleteTask: {
                ...task, __typename: 'Task', comments: { __typename: 'CommentConnection', items: [] }
              }
            }),
          });
        }
      })
    }
  )
)(ListTasks));
